import React from 'react'
import Link from 'next/link'
import { Author } from '../../models/blog'

interface AuthorProps {
  author: Author
}

export default function AuthorView({ author }: AuthorProps) {
  return (
    <div className="flex flex-col p-8 mb-4 bg-gray-100 border rounded-md lg:flex-row">
      <div className="flex items-center justify-center lg:justify-start mb-4 lg:mb-0 lg:mr-8">
        <Link
          href={`/blog/author/${author.name
            .toLowerCase()
            .split(' ')
            .join('-')}-${author.id}`}
        >
          <a className="w-max">
            <img
              className="w-48 h-48 rounded-full"
              alt={author.name}
              src={author.gravatar}
              width="1rem"
              height="1rem"
            />
          </a>
        </Link>
      </div>
      <div className="flex flex-col justify-center items-center lg:items-start">
        <div className="mb-4">
          <Link
            href={`/blog/author/${author.name
              .toLowerCase()
              .split(' ')
              .join('-')}-${author.id}`}
          >
            <a className="text-2xl font-bold tracking-widest capitalize author-name">
              {author.name}
            </a>
          </Link>
        </div>

        <p
          className="mb-4 text-center lg:text-left"
          dangerouslySetInnerHTML={{ __html: author.description }}
        />
        <div className="flex flex-wrap justify-center space-x-4 lg:justify-start">
          {author && (
            <a href={'https://majordomo.com/'} target="_blank">
              <img src={'/share/wb.png'} className="object-contain w-12 h-12" />
            </a>
          )}
          {author.facebook && (
            <a href={author.facebook} target="_blank">
              <img src={'/share/fb.png'} className="object-contain w-12 h-12" />
            </a>
          )}

          {author.linkedin && (
            <a href={author.linkedin} target="_blank">
              <img src={'/share/lk.png'} className="object-contain w-12 h-12" />
            </a>
          )}
          {author.twitter && (
            <a href={author.twitter} target="_blank">
              <img src={'/share/tw.png'} className="object-contain w-12 h-12" />
            </a>
          )}
        </div>
      </div>
    </div>
  )
}
